import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal
} from '@material-ui/core';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';
import ExpenseTypeDetails from 'components/Expenses/ExpenseTypeDetails';

import { deleteExpenseType } from 'redux/actions';
import { Employee_Salary, Employee_Expense, Petty_Expense } from 'variables/expenseTypes';

const ExpenseTypesTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.expenseTypes.length; i++ ) {
      initialTableData.push({
        name: props.expenseTypes[i].name,
        vatable: props.expenseTypes[i].vatable ? "Yes" : "No"
      });
    }
    
    return initialTableData;

  }, [props.expenseTypes]);

  const columns = [
    { name: 'name', label: 'Type' },
    { name: 'vatable', label: 'Vatable' }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
  };

  const deleteExpenseTypes = () => {

    const deletedName = tableData[rowsSelected[0]].name;
    const typeInUse = (
      [ Employee_Salary, Employee_Expense, Petty_Expense ].includes(deletedName) ||
      props.expenses.some(expense => expense.type === deletedName)
    );

    if(typeInUse) setOpenDeleteModal(true);
    else props.deleteExpenseType(deletedName);

    setRowsSelected([]);
  };
  
  const handleDeleteModalClose = () => {
    setOpenDeleteModal(false);
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={4}
        element="Expense Type"
        setDelete={deleteExpenseTypes}
      />
    )
  };

  const options = {
    filterType: 'checkbox',
    rowsSelected,
    selectableRows: 'single',
    selectableRowsOnClick: true,
    onRowSelectionChange,
    customToolbarSelect,
    download: false,
    print: false,
    filter: false,
    viewColumns: false
  };

  return (
    <React.Fragment>
      <Box display="flex" flexDirection="row">
        <Box width="50%" marginRight={1}>
          <MUIDataTable 
            title={"Expense Types"}
            data={tableData}
            columns={columns}
            options={options}
          />
        </Box>
        <Box width="50%">
          <ExpenseTypeDetails />
        </Box>
      </Box>
      { openDeleteModal ?
        <Modal
          open={openDeleteModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20%'
          }}
        >
          <Card>
            <CardHeader
              title="Cannot Delete."
            />
            <Divider />
            <CardContent>
                <p> The Type(s) is still in use. <br/>
                Change Type of elements and try again.
                {} </p>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDeleteModalClose}
                >
                  Ok
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Modal>
      : null }
    </React.Fragment>
  )
};

export default connect (null, {deleteExpenseType}) (ExpenseTypesTable);